import React from "react";
import ErrorPage from "components/errors/ErrorPage";
import { Link } from "components/common";
import Routes from "routing/Routes";
const NotFoundPage = ({ displayPageLayout = true }) => {
  const description = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "The page you are looking for does not exist (anymore)."), /* @__PURE__ */ React.createElement("p", null, "You can head back to the ", /* @__PURE__ */ React.createElement(Link, { to: Routes.WELCOME }, "Main Page"), " and navigate from there."));
  return /* @__PURE__ */ React.createElement(ErrorPage, { title: "Page not found", description, displayPageLayout });
};
export default NotFoundPage;
